import React from 'react';

function List(props) {
  return (
    <svg fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        clipRule="evenodd"
        d="M9.375 12C9.375 11.6548 9.65482 11.375 10 11.375H20.4C20.7452 11.375 21.025 11.6548 21.025 12C21.025 12.3452 20.7452 12.625 20.4 12.625H10C9.65482 12.625 9.375 12.3452 9.375 12Z"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M9.375 5C9.375 4.65482 9.65482 4.375 10 4.375H20.4C20.7452 4.375 21.025 4.65482 21.025 5C21.025 5.34518 20.7452 5.625 20.4 5.625H10C9.65482 5.625 9.375 5.34518 9.375 5Z"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M9.375 19C9.375 18.6548 9.65482 18.375 10 18.375H20.4C20.7452 18.375 21.025 18.6548 21.025 19C21.025 19.3452 20.7452 19.625 20.4 19.625H10C9.65482 19.625 9.375 19.3452 9.375 19Z"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M4.25 12C4.25 12.5523 4.69772 13 5.25 13C5.80228 13 6.25 12.5523 6.25 12C6.25 11.4477 5.80228 11 5.25 11C4.69772 11 4.25 11.4477 4.25 12ZM5.25 9.75C4.00736 9.75 3 10.7574 3 12C3 13.2426 4.00736 14.25 5.25 14.25C6.49264 14.25 7.5 13.2426 7.5 12C7.5 10.7574 6.49264 9.75 5.25 9.75Z"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M4.25 5C4.25 5.55228 4.69772 6 5.25 6C5.80228 6 6.25 5.55228 6.25 5C6.25 4.44772 5.80228 4 5.25 4C4.69772 4 4.25 4.44772 4.25 5ZM5.25 2.75C4.00736 2.75 3 3.75736 3 5C3 6.24264 4.00736 7.25 5.25 7.25C6.49264 7.25 7.5 6.24264 7.5 5C7.5 3.75736 6.49264 2.75 5.25 2.75Z"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M4.25 19C4.25 19.5523 4.69772 20 5.25 20C5.80228 20 6.25 19.5523 6.25 19C6.25 18.4477 5.80228 18 5.25 18C4.69772 18 4.25 18.4477 4.25 19ZM5.25 16.75C4.00736 16.75 3 17.7574 3 19C3 20.2426 4.00736 21.25 5.25 21.25C6.49264 21.25 7.5 20.2426 7.5 19C7.5 17.7574 6.49264 16.75 5.25 16.75Z"
        fillRule="evenodd"
      />
    </svg>
  );
}

export default List;
